var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testDetail"},[_c('questionDetail',{attrs:{"show-bottom":true,"has-result":_vm.hasResult,"list":_vm.list,"total":_vm.total}}),_c('index-bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }